const Color = [
  {
    bgPanel: "var(--tab-pn-all)",
    bgTab: "var(--tab-all)",
  },
  {
    bgPanel: "var(--tab-pn-recommendation)",
    bgTab: "var(--tab-recommendation)",
  },
  {
    bgPanel: "var(--tab-pn-viewing)",
    bgTab: "var(--tab-viewing)",
  },
  {
    bgPanel: "var(--tab-pn-participation)",
    bgTab: "var(--tab-participation)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
  {
    bgPanel: "var(--tab-pn-others)",
    bgTab: "var(--tab-others)",
  },
];

export { Color };
